import React from "react"
import { graphql } from "gatsby"
import WPGBlocks, { IWPGBlock } from "react-gutenberg"

import Layout from "~/layouts"
import GetCustomBlock from '~/blocks'
import styled from "styled-components"
import { Container } from "~/styles/Elements"

interface IPost {
  wordpress_id: number
  id: number
  title: string
  excerpt: string
  slug: string
  type: string
  date: string
  categories: {
    name: string
    slug: string
  }
  blocks: IWPGBlock[]
}

const Post: React.SFC<{data: { post: IPost }}> = ({ data }) => {
  const { id, title, blocks } = data.post

  return (
    <Layout>
      <Container data-id={id}>
        <h2>{title}</h2>
        <WPGBlocks blocks={blocks} mapToBlock={GetCustomBlock} />
      </Container>
    </Layout>
  )
}

export default Post

export const pageQuery = graphql`
  fragment imageFile on wordpress__wp_media {
    localFile {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
  fragment WPPost on wordpress__POST{
      wordpress_id
      id
      title
      excerpt
      slug
      type
      date
      categories {
        name
        slug
      }
  }
  fragment Blocks on wordpress__POSTBlocks {
    blockName
    innerHTML
    innerBlocks {
      blockName
      innerHTML
      innerBlocks {
        blockName
        innerHTML
        attrs {
          avatar
          blockId
          blockUniqueClass
          display_name
          info
          job_title
        }
      }
    }
  }
  query PostById($id: String!) {
    post: wordpressPost(id: { eq: $id }) {
      ...WPPost
      blocks {
        ...Blocks
      }
    }
  }
`

const Article = styled.div`
  display: block;
  max-width: 960px;
  margin: 1rem auto;
  width: 100%;
`
